import './components/dinamicHeight';
import './components/drawer';
import './components/modals';
import './components/switcher';
import './components/select';

import './components/cursor';
import './components/sliders';
import './components/filter-cases';
import './components/filter-services';
import './components/map';
import './components/form-validate';
// import './components/animations';

